import { set } from "idb-keyval";
import { enable_host_autoselect_key } from "./constants";

export default async (value) =>
  await set(enable_host_autoselect_key, value);
